import PropTypes from "prop-types";
import { Box } from "@mui/material";

// A quick white flash over the camera preview, one per captured image.
// `count` is the running capture count: every increment replays the flash
// (the Box is keyed by it, so it remounts and the animation restarts).
export const CaptureFlash = ({ count }) => {
  if (!count) return null;

  return (
    <Box
      key={count}
      sx={{
        position: "absolute",
        inset: 0,
        backgroundColor: "#fff",
        pointerEvents: "none",
        opacity: 0,
        // subtle on purpose: this plays once a second through a whole scan.
        animation: "captureFlash 180ms ease-out",
        "@keyframes captureFlash": {
          "0%": { opacity: 0.2 },
          "100%": { opacity: 0 },
        },
      }}
    />
  );
};

CaptureFlash.propTypes = { count: PropTypes.number };
